module.exports = __webpack_public_path__ + "static/media/john_michael.453ed0bf.jpg";